import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import { AuthProvider } from './context/AuthContext';
import AppLayout from './components/AppLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import KiralikListe from './pages/kiralik/KiralikListe';
import KiralikForm from './pages/kiralik/KiralikForm';
import SatilikListe from './pages/satilik/SatilikListe';
import SatilikForm from './pages/satilik/SatilikForm';
import KiraSozlesmeListe from './pages/sozlesme/KiraSozlesmeListe';
import KiraSozlesmeForm from './pages/sozlesme/KiraSozlesmeForm';
import SatisSozlesmeListe from './pages/satissozlesme/SatisSozlesmeListe';
import SatisSozlesmeForm from './pages/satissozlesme/SatisSozlesmeForm';
import AramaListe from './pages/aramalar/AramaListe';
import AramaForm from './pages/aramalar/AramaForm';
import SunumlarPage from './pages/sunumlar/SunumlarPage';
import ProjeTanimPage from './pages/projeler/ProjeTanimPage';
import ProjeForm from './pages/projeler/ProjeForm';
import ProjeSatisListe from './pages/projesatis/ProjeSatisListe';
import ProjeSatisForm from './pages/projesatis/ProjeSatisForm';
import KullanicilarPage from './pages/kullanicilar/KullanicilarPage';

dayjs.locale('tr');

const PrivateRoute = ({ children, adminOnly = false }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (adminOnly) {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.rol !== 'Yönetici') {
        return <Navigate to="/dashboard" replace />;
      }
    } catch {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return children;
};

function App() {
  return (
    <ConfigProvider locale={trTR} theme={{ token: { colorPrimary: '#1677ff' } }}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <AppLayout />
                </PrivateRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />

              {/* Kiralık */}
              <Route path="kiralik" element={<KiralikListe />} />
              <Route path="kiralik/yeni" element={<KiralikForm />} />
              <Route path="kiralik/:id/duzenle" element={<KiralikForm />} />

              {/* Satılık */}
              <Route path="satilik" element={<SatilikListe />} />
              <Route path="satilik/yeni" element={<SatilikForm />} />
              <Route path="satilik/:id/duzenle" element={<SatilikForm />} />

              {/* Kira Sözleşmesi */}
              <Route
                path="kira-sozlesmesi"
                element={
                  <PrivateRoute adminOnly>
                    <KiraSozlesmeListe />
                  </PrivateRoute>
                }
              />
              <Route path="kira-sozlesmesi/:kiralikId" element={<KiraSozlesmeForm />} />

              {/* Satış Sözleşmesi */}
              <Route
                path="satis-sozlesmesi"
                element={
                  <PrivateRoute adminOnly>
                    <SatisSozlesmeListe />
                  </PrivateRoute>
                }
              />
              <Route path="satis-sozlesmesi/:satilikId" element={<SatisSozlesmeForm />} />

              {/* Aramalar */}
              <Route path="aramalar" element={<AramaListe />} />
              <Route path="aramalar/yeni" element={<AramaForm />} />
              <Route path="aramalar/:id/duzenle" element={<AramaForm />} />

              {/* Sunumlar */}
              <Route path="sunumlar" element={<SunumlarPage />} />

              {/* Projeler */}
              <Route
                path="projeler"
                element={
                  <PrivateRoute adminOnly>
                    <ProjeTanimPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="projeler/yeni"
                element={
                  <PrivateRoute adminOnly>
                    <ProjeForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="projeler/:id/duzenle"
                element={
                  <PrivateRoute adminOnly>
                    <ProjeForm />
                  </PrivateRoute>
                }
              />

              {/* Proje Satış */}
              <Route path="proje-satis" element={<ProjeSatisListe />} />
              <Route path="proje-satis/yeni" element={<ProjeSatisForm />} />
              <Route path="proje-satis/:id/duzenle" element={<ProjeSatisForm />} />

              {/* Kullanıcılar */}
              <Route
                path="kullanicilar"
                element={
                  <PrivateRoute adminOnly>
                    <KullanicilarPage />
                  </PrivateRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
